module.exports = __webpack_public_path__ + "img/fondo_new.807b5abe.png";